export const FETCH_BILL_PAYMENT_SERVICES = 'BillPaymentServices/FETCH';
export const FETCH_BILL_PAYMENT_SERVICES_SUCCESS = 'BillPaymentServices/FETCH_SUCCESS';
export const FETCH_BILL_PAYMENT_SERVICES_FAIL = 'BillPaymentServices/FETCH_FAIL';

/* eslint-disable */
const BillPaymentServicesReducer = (state = {}, action = {}) => {
  switch (action.type) {
    case FETCH_BILL_PAYMENT_SERVICES:
      return {
        ...state,
        [action.payload.vendorId]: {
          isLoading: true,
          isLoaded: false,
          services: [],
        },
      };
    case FETCH_BILL_PAYMENT_SERVICES_SUCCESS:
      return {
        ...state,
        [action.payload.vendorId]: {
          isLoading: false,
          isLoaded: true,
          services: action.payload.data,
          statusCode: action.payload.statusCode,
        },
      };
    case FETCH_BILL_PAYMENT_SERVICES_FAIL:
      return {
        ...state,
        [action.payload.vendorId]: {
          isLoaded: false,
          isLoading: false,
          error: action.error,
          services: [],
          statusCode: action.payload.statusCode,
        },
      };
    default:
      return { ...state };
  }
};

export default BillPaymentServicesReducer;
